import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_item_ext_RowClass, bl_fi_mst_item_ext_RowInterface } from '../../dbschema/index';

export class SettlementMethodExtContainerModel extends BaseContainerModel {
  bl_fi_mst_item_ext: bl_fi_mst_item_ext_RowInterface = new bl_fi_mst_item_ext_RowClass();
}
